import { useMediaQuery } from "@mui/material";
import { LineChart } from "@mui/x-charts";
import React, { useEffect, useState } from "react";

const TrendsChart = ({ categoryName, data, type }) => {
  const [seriesData, setSeriesData] = useState([]);
  const isMobile = useMediaQuery("(max-width: 750px)");
  const isCurrentMonthValueZero = (d) => {
    let currentDate = new Date();
    let currentMonthIndex = currentDate.getMonth();
    let currentYear = currentDate.getFullYear();
    let apiDate = new Date(d?.monthYear);
    let apiMonthIndex = apiDate.getMonth();
    let apiYear = apiDate.getFullYear();

    if (currentMonthIndex === apiMonthIndex && currentYear === apiYear) {
      if (type === 1) {
        if (!d?.maxTxnAmount) return true;
      } else {
        if (!d?.maxPercentage) return true;
      }
    }
    return false;
  };
  useEffect(() => {
    if (data.length) {
      let filteredData = [];
      data.forEach((d) => {
        if (!isCurrentMonthValueZero(d)) {
          filteredData.push(d);
        }
      });

      setSeriesData(filteredData);
    }
  }, [data]);

  const convertDateFormat = (dateString) => {
    const [month, year] = dateString.split(", ");
    return month.substring(0, 3) + " '" + year.substring(2);
  };

  return (
    <div className="graph-box">
      <div className="graph-title">
        <p className="text1"> Expense Trend : {categoryName} </p>
        <p className="text2">(Last 15 months)</p>
      </div>
      <LineChart
        xAxis={[
          {
            scaleType: "point",
            data: seriesData?.map((d) => convertDateFormat(d?.monthYear)) || [],
          },
        ]}
        yAxis={[
          {
            valueFormatter: (value) =>
              value == 0 ? null : type == 1 ? `$${value}` : `${value}%`,
            tickNumber: 5,
            min: 0,
          },
        ]}
        series={[
          {
            curve: "linear",
            data:
              seriesData?.map((d) => {
                if (type == 1) {
                  return d?.maxTxnAmount;
                }
                return d?.maxPercentage;
              }) || [],
            label: "Max",
            valueFormatter: (d) => (type == 1 ? `$${d}` : `${d}%`),
            color: "var(--color14)",
          },
          {
            curve: "linear",
            data:
              seriesData?.map((d) => {
                  return d?.avgTxnAmount;
              }) || [],
            label: "Average",
            valueFormatter: (d) => `$${d}`,
            color: "grey",
          },
          {
            curve: "linear",
            data:
              seriesData?.map((d) => {
                if (type == 1) {
                  return d?.medianTxnAmount;
                }
                return d?.medianPercentage;
              }) || [],
            label: "Median",
            valueFormatter: (d) => (type == 1 ? `$${d}` : `${d}%`),
            color: "var(--color24)",
          },
          {
            curve: "linear",
            data:
              seriesData?.map((d) => {
                if (type == 1) {
                  return d?.minTxnAmount;
                }
                return d?.minPercentage;
              }) || [],
            label: "Min",
            valueFormatter: (d) => (type == 1 ? `$${d}` : `${d}%`),
            color: "var(--color3)",
          },
        ]}
        sx={{
          height: "100%",
          width: 300,
          ".MuiMarkElement-root": {
            scale: "0",
          },
          ".MuiChartsLegend-mark": {
            height: isMobile ? 10 : 12,
            width: isMobile ? 10 : 12,
          },
          ".MuiChartsLegend-series text": {
            fontSize: `${isMobile ? 12 : 14}px !important`,
            transform: `translateY(${isMobile ? -5 : -4}px)`,
          },
          ".MuiLineElement-series-auto-generated-id-1": {
            strokeDasharray: 4
          },
          ".MuiLineElement-series-auto-generated-id-2": {
            strokeWidth: 3
          }
        }}
      />
    </div>
  );
};

export default TrendsChart;
